import type { FormErrors } from 'redux-form';

import type { W_MaterialJobMarkupHistory_Upsert_RM } from 'ab-api/web/materialJobMarkupHistory/upsert';

class MaterialJobMarkupFM {
	shippingMarkup: Nullable<number>;
	salesMarkup: Nullable<number>;
	tax: Nullable<number>;

	constructor(initial?: Partial<MaterialJobMarkupFM>) {
		this.shippingMarkup = initial?.shippingMarkup ?? null;
		this.salesMarkup = initial?.salesMarkup ?? null;
		this.tax = initial?.tax ?? null;
	}

	static field(key: keyof MaterialJobMarkupFM) {
		return key;
	}

	static validate(form: MaterialJobMarkupFM) {
		const errors: FormErrors<MaterialJobMarkupFM> = {};

		if (!!form.salesMarkup && form.salesMarkup < 0) {
			errors.salesMarkup = 'Sales markup must be a non-negative value';
		}

		if (!!form.shippingMarkup && form.shippingMarkup < 0) {
			errors.shippingMarkup = 'Shipping markup must be a non-negative value';
		}

		if (!!form.tax && form.tax < 0) {
			errors.tax = 'Tax must be a non-negative value';
		}

		return errors;
	}

	static toRM(form: MaterialJobMarkupFM): W_MaterialJobMarkupHistory_Upsert_RM {
		return {
			shippingMarkup: !!form.shippingMarkup ? (+form.shippingMarkup) : 0,
			salesMarkup: !!form.salesMarkup ? (+form.salesMarkup) : 0,
			tax: !!form.tax ? (+form.tax) : 0,
		};
	}
}

export default MaterialJobMarkupFM;
